import { faArrowLeft, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FormControlLabel, IconButton, MobileStepper, Radio, RadioGroup, Typography } from "@mui/material";
import { useState } from "react";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { QuestionarioEmailCelOpcoes } from "../../../interfaces/entities/QuestionarioEmailCelOpcoes";
import { RecoveryQuestionsProps } from "../../../interfaces/props/passwordRecovery/RecoveryQuestionsProps";
import { sxButtonOptionRecovery, sxTypographyTitleLeft, sxValidationMessage } from "../sxProps";


const RecoveryQuestions: React.FC<RecoveryQuestionsProps> = ({
  questions,
  formBack,
  allowChangeData
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [showError, setShowError] = useState<boolean>(false);
  const [listAnswersOptions, setListAnswersOptions] = useState<Array<QuestionarioEmailCelOpcoes>>([]);

  const nextQuestion = () => {
    const isAnswerMissing = !listAnswersOptions[activeStep]?.guIDQuestao;

    if (isAnswerMissing) {
      setShowError(true);
      return;
    };

    if (activeStep !== (questions.length - 1)) {
      setShowError(false);
      setActiveStep(activeStep + 1);
      return;
    };

    allowChangeData(listAnswersOptions);
  };


  const handleAnswersChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedOption = e.target.value;
    const selectedOptionGuID = questions[activeStep]?.listaOpcoes?.find(item => item.opcao === selectedOption)?.guID || "";

    var optionAnswer: QuestionarioEmailCelOpcoes = {
      guIDResposta: selectedOptionGuID,
      guIDQuestao: questions[activeStep]?.guID
    };

    var answers = listAnswersOptions;
    answers.push(optionAnswer);

    setListAnswersOptions(answers);
  }

  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();

  return (
    <div style={textStyleAccessibility} className='container-login-painel-rigth'>
      <div className='password-recovery-container-text'>
        <div className='width-100'>
          <IconButton aria-label="Voltar" onClick={() => formBack()} type="button">
            <FontAwesomeIcon style={textStyleAccessibility} icon={faArrowLeft} />
          </IconButton>
          <Typography component="h1" style={textStyleAccessibility} sx={sxTypographyTitleLeft} className='margin-bottom-painel-rigth'>Questionário</Typography>
        </div>
        <div className='container-text-recovery '>
          <div className='width-100'  aria-label={questions[activeStep].descrQuestao}>
            <Typography sx={{ textAlign: 'start', color: '#4C4C4C' }}>{questions[activeStep].descrQuestao}</Typography>
          </div>
          <div className='width-100'>
            <RadioGroup onChange={handleAnswersChange} aria-label={questions[activeStep].descrQuestao}>
              {questions[activeStep].listaOpcoes?.map((item, index) =>
                <FormControlLabel key={index} value={item.opcao}
                  control={<Radio style={{ background: 'white' }} color='default' />}
                  label={
                    <div>
                      <Typography style={{ color: '#4C4C4C', ...textStyleAccessibility}}>{item.opcao}</Typography>
                    </div>
                  } />
              )}
            </RadioGroup>
          </div>
          <MobileStepper
            variant="dots"
            steps={questions.length}
            position="static"
            activeStep={activeStep}
            sx={{ maxWidth: 400, flexGrow: 1 }}
            nextButton={<></>}
            backButton={<></>}
          />
        </div>
        {showError && (
          <div className="container-validation-message">
            <FontAwesomeIcon icon={faCircleExclamation} size='sm' color='#D84141' />
            <Typography sx={sxValidationMessage} style={textStyleAccessibility}>
              {'Por favor, selecione uma opção antes de continuar.'}
            </Typography>
          </div>
        )}
        <Button style={buttonStyleAccessibility} sx={sxButtonOptionRecovery} onClick={() => nextQuestion()} variant='contained'>
          <Typography style={buttonTextStyleAccessibility}>CONTINUAR</Typography>
        </Button>
      </div>
    </div>
  )
}

export default RecoveryQuestions